import { ReactNode } from 'react';
import { ClerkProvider } from '@clerk/clerk-react';

// Clerk keys by environment
const CLERK_PROD_KEY = "pk_live_Y2xlcmsuZWxldmFkdmlzb3IuY29tJA";
const CLERK_DEV_KEY = "pk_test_aW50ZXJuYWwtY2hpbXAtOTMuY2xlcmsuYWNjb3VudHMuZGV2JA";

// Auto-select based on hostname
const isProduction = typeof window !== 'undefined' && 
  (window.location.hostname === 'elevadvisor.com' || 
   window.location.hostname === 'www.elevadvisor.com');

const CLERK_PUBLISHABLE_KEY = isProduction ? CLERK_PROD_KEY : CLERK_DEV_KEY;

// Detect bots/crawlers to avoid unnecessary Clerk API calls that would fail
const isBot = typeof navigator !== 'undefined' && (
  /bot|crawl|spider|lighthouse|headless|phantom|puppeteer|selenium/i.test(navigator.userAgent) ||
  !navigator.userAgent
);

interface ClerkProviderWrapperProps {
  children: ReactNode;
}

export function ClerkProviderWrapper({ children }: ClerkProviderWrapperProps) {
  // Skip Clerk for bots/crawlers to prevent 400 errors in Lighthouse
  if (isBot) {
    return <>{children}</>;
  }

  if (!CLERK_PUBLISHABLE_KEY) {
    console.error("Missing Clerk Publishable Key");
    return <>{children}</>;
  }

  return (
    <ClerkProvider publishableKey={CLERK_PUBLISHABLE_KEY}>
      {children}
    </ClerkProvider>
  );
}
